import React from "react";
import styled from "styled-components";

import themeGet from "@/utils/theme-gets";

import type { VirtualizeOptionProps } from "../../../models/VirtualizeOptionStyle";

const NO_RESULTS_LABEL = "No results";

export const NoResultsOption: React.FC<VirtualizeOptionProps> = ({ virtualizedStyle }) => {
  return (
    <NoResultsOptionWrapper style={virtualizedStyle}>
      <NoResultsLabel>{NO_RESULTS_LABEL}</NoResultsLabel>
    </NoResultsOptionWrapper>
  );
};

const NoResultsOptionWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const NoResultsLabel = styled.span`
  color: ${themeGet("color.foreground.text.secondary")};
  font: ${themeGet("typography.body.bolder.s")};
`;
